import React from 'react';
import styled from 'styled-components';
import { fadeIn } from '../../../../constants/keyframes/fades';
import { formatCurrency } from '../../../../helpers/formatting/formatting';
import IExpressService from '../../../../interfaces/sendReceipt/expressServices';
import ISendReceipt from '../../../../interfaces/sendReceipt/sendReceiptMultistep';
import FormikFieldWrapper from '../../../base/forms/formikFieldWrapper';
import FormikRadioTile from '../../../base/forms/formikRadioTile/formikRadioTile';
import { getIconByServiceCode } from '../../../sendReceipt/sendReceiptForm/delivery/helpers';

export const DEFAULT_DELIVERY_SERVICE: { [key: string]: IExpressService } = {
	is: {
		serviceHeader: 'Almenn afhending - engin viðbótarþjónusta',
		serviceText: 'Sending fer í afhendingarferli. Afgreiðslutími 2-3 virkir dagar',
		serviceCode: '0',
		amount: '0.00',
	},
	en: {
		serviceHeader: 'Default processing',
		serviceText: 'Shipment will get default process. 2-3 work days',
		serviceCode: '0',
		amount: '0.00',
	},
};

const StyledService = styled.div`
	display: block;
	width: 100%;
	margin-bottom: 2rem;
	animation: ${fadeIn} 400ms linear;
`;

const StyledDescription = styled.div`
	margin-bottom: 3rem;
`;

type ServiceProps = {
	values: ISendReceipt;
	setFieldValue: (field: string, value: any) => void;
	services: IExpressService[];
};

const Services = ({ setFieldValue, services, values }: ServiceProps) => {
	return (
		<div>
			{/* {loading && [...Array(3)].map((_key, index) => <FormikRadioTileLoader key={index} />)} */}
			<FormikFieldWrapper name="deliveryService" languageComponent="sendReceipt">
				{services &&
					services.map((service, index) => (
						<div key={index}>
							<StyledService>
								<FormikRadioTile
									id={service.serviceCode}
									name="deliveryService"
									icon={getIconByServiceCode(service.serviceCode)}
									setFieldValue={setFieldValue}
									label={service.serviceHeader}
									price={formatCurrency(service.amount.slice(0, service.amount.length - 3))}
									estDeliveryTime={service.serviceText}
									active={values.deliveryService === service.serviceHeader}>
									<StyledDescription>{service.serviceText}</StyledDescription>
								</FormikRadioTile>
							</StyledService>
						</div>
					))}
			</FormikFieldWrapper>
		</div>
	);
};

export default Services;
